import React, { useState } from 'react';
import { IoIosClose } from "react-icons/io";

const Toast = ({ message, type, onClose }) => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    onClose();
  };

  return (
    <div
      className={`fixed bottom-0 right-0 mb-2 mr-2 p-4 rounded-xl ${
        type === 'success' ? 'bg-green-500' : 'bg-red-500'
      } ${show ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
    >
      <p className="text-white">{message}</p>
      <button
        className="absolute top-0 right-0   text-white hover:text-gray-200 focus:outline-none"
        onClick={handleClose}
      >
       <IoIosClose className='w-6 h-6' />
  
      </button>
    </div>
  );
};

export default Toast;
